import React from 'react'
import cx from 'classnames'

import { AdoptionComponent } from '../../constants/AdoptionComponent'
import { useDsAdoptionAttribute } from '../../utils/dsAdoption'
import { DS_CONTAINER_PARAMETER } from '../../utils/dsAdoption/constants'

import { CardAction } from './CardAction'
import { CardProps } from './interfaces'

import cm from './Card.module.css'

const CardElement = <T extends React.ElementType = 'div'>({
  disabled,
  className,
  children,
  as,
  forwardedRef,
  ...rest
}: CardProps<T>) => {
  const adoptionAttribute = useDsAdoptionAttribute(AdoptionComponent.CARD)

  const cardClasses = cx(cm.card, className, { [cm.disabled]: disabled })
  const CardComponent = as ?? 'div'
  const hasAdoptionAttribute = Object.keys(adoptionAttribute).length > 0

  return (
    <CardComponent
      {...rest}
      ref={forwardedRef}
      className={cardClasses}
      data-test-component="card"
      {...adoptionAttribute}
      {...(hasAdoptionAttribute ? { [DS_CONTAINER_PARAMETER]: true } : {})}
    >
      {children}
    </CardComponent>
  )
}

export const Card = Object.assign(CardElement, {
  Action: CardAction,
})
